import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Container,
  Divider,
  Grid,
  Hidden,
  Typography,
} from "@material-ui/core";
import fontConfig from "../../constants/fonts";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";

import CarouselBtn from "../../components/Common/Buttons/CarouselBtn";
import TitleContainer from "./TitleContainer";
import UseMobile from "../../hooks/useIsMobile";
import LayoutContainer from "../../components/LayoutsContainer";
import MobileHidden from "../../components/Common/Hidden/MobileHidden";
import DesktopHidden from "../../components/Common/Hidden/DesktopHidden";

import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import AchievementItem from "../../Layouts/Achievements/AchievemntItem";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(2),
    // backgroundColor: theme.palette.primary.lightGray,
    [theme.breakpoints.down("md")]: {
      // height: "100%",
      paddingTop: theme.spacing(2),
      // paddingBottom: theme.spacing(0),
    },
  },
  Divider: {
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down("md")]: {},
  },
  titleContainer: {
    [theme.breakpoints.down("md")]: {
      // backgroundColor: "yellow",
    },
  },
  title: {
    ...fontConfig.bold,
    fontSize: "2rem",
    color: "white",
    backgroundColor: theme.palette.primary.main,
    // awidth: "20%",
    // width: "15%",
    textAlign: "center",
    padding: 10,
    // padding: "10 30px",
    // wordWrap: "no-wrap",
  },
  personalityContainer: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  CarouselProvider: {
    marginTop: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(2),
      // backgroundColor: "red",
    },
  },
  btns: {
    backgroundColor: "transparent",
    border: "none",
  },
  gridContainer: {
    // backgroundColor: "red",
    width: "100%",
    backgroundColor: theme.palette.lightGray,
  },
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
}));

const PortFolio = ({ data }) => {
  const classes = useStyles();
  const isMobile = UseMobile();
  const SliderItems = data?.data?.map((item, index) => {
    return <AchievementItem data={item} />;
  });
  return (
    data?.data?.length > 0 && (
      <div className={classes.container}>
        <LayoutContainer>
          <div className={classes.root}>
            <Grid container>
              <Grid item lg={10} md={10} xs={12} sm={12}>
                {data.title && (
                  <>
                    <MobileHidden>
                      <Grid container className={classes.gridContainer}>
                        <Grid item className={classes.titleContainer}>
                          <TitleContainer title={data.title} />
                        </Grid>
                      </Grid>
                    </MobileHidden>
                    <DesktopHidden>
                      <Grid
                        container
                        justify="center"
                        className={classes.gridContainer}
                      >
                        <Grid item className={classes.titleContainer}>
                          <TitleContainer title={data.title} />
                        </Grid>
                      </Grid>
                    </DesktopHidden>
                  </>
                )}
              </Grid>
              <Hidden mdDown>
                <Grid
                  item
                  lg={2}
                  justify="space-evenly"
                  alignItems="center"
                  container
                >
                  {/* <Grid item>
                  <ButtonBack className={classes.btns}>
                    <CarouselBtn type="back" />
                  </ButtonBack>
                </Grid>
                <Grid item>
                  <ButtonNext className={classes.btns}>
                    <CarouselBtn type="next" />
                  </ButtonNext>
                </Grid> */}
                </Grid>
              </Hidden>
            </Grid>

            <div className={classes.CarouselProvider}>
              <AliceCarousel
                autoPlay={data?.data?.length > 4}
                disableButtonsControls
                disableDotsControls
                infinite
                autoPlayInterval={3000}
                mouseTracking
                items={SliderItems}
                responsive={{
                  0: {
                    items: 3,
                  },

                  600: {
                    items: 4,
                    autoPlayInterval: 5000,
                  },
                  500: {
                    items: 2,
                    autoPlayInterval: 5000,
                  },
                  200: {
                    items: 1,
                    autoPlayInterval: 5000,
                  },
                  960: {
                    items: 4,
                    autoPlayInterval: 5000,
                  },
                  1280: {
                    items: 4,
                    autoPlayInterval: 5000,
                  },
                }}
              />
              {/* <Slider>
                {data?.data?.map((man, index) => {
                  return (
                    <Slide index={index} key={index}>
                      <AchievementItem data={man} />
                    </Slide>
                  );
                })}
              </Slider> */}
            </div>
          </div>
        </LayoutContainer>
      </div>
    )
  );
};
export default PortFolio;
